import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { PagesViewedMostConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "pages-viewed-details",
  templateUrl: "./pages-viewed-details.component.html",
  standalone: false,
})
export class PagesViewedDetailsComponent
  extends BaseDetailsLogic<PagesViewedMostConfig>
  implements OnInit, OnDestroy
{
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(
      analyticsService,
      authService,
      loggingService,
      PagesViewedMostConfig,
      tooltipCoordinator
    );
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedMinViewed(): number {
    return this.config?.minViewed;
  }

  set selectedMinViewed(value: number) {
    this.config.minViewed = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedNumberResults(): number {
    return this.config?.numberResults;
  }

  set selectedNumberResults(value: number) {
    this.config.numberResults = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod:
        "Pick a time period to see data for that range. For example, you can look at results from the last week, month, or year. This helps you understand when things are happening.",
      minViewed:
        "Set the minimum number of times a page must be viewed to appear in the list. For example, if you enter 5, you will only see pages that were viewed at least 5 times. This helps you focus on the most visited pages.",
      numberResults:
        "Set how many items you want to see in the list. For example, if you enter 10, you will see the top 10 items. This helps you focus on the most or least popular items, depending on the chart.",
    };
  }
}
